import { Spinner } from '@wartek-id/spinner'

import KinerjaSidebar from 'app/KinerjaShared/components/KinerjaSidebar'
import CardKinerjaSteps from 'app/KinerjaShared/components/CardKinerjaSteps'
import CardReferensi from 'app/KinerjaPage/components/CardReferensi'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import KepalaSekolahRootView from '../components/KepalaSekolahRootView'
import SimulationMode from '../components/SimulationMode'
import CardReferensiPenilaian from 'app/KinerjaPage/pages/PelaksanaanV2/CardReferensiPenilaian'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

interface BerandaKepalaSekolahPenilaiProps {
  isKinerjaPelaksanaanEnabled?: boolean
  isKinerjaPenilaianDemoEnabled?: boolean
}

const BerandaKepalaSekolahPenilai = ({
  isKinerjaPelaksanaanEnabled = false,
  isKinerjaPenilaianDemoEnabled = false,
}: BerandaKepalaSekolahPenilaiProps) => {
  const { isLoading, profile } = useRoleContext()
  const { periods } = usePeriodContext()

  const isPeriodResolved = Array.isArray(periods) && periods.length > 0
  const isNotReady = isLoading || !isPeriodResolved

  return (
    <div className="pl-64">
      <KinerjaSidebar sticky activeMenu="ks-penilai" />
      <div className="p-6 flex flex-col gap-6 w-full">
        {isNotReady ? (
          <div className="w-full flex justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <KepalaSekolahRootView
              profile={profile}
              isKinerjaPelaksanaanEnabled={isKinerjaPelaksanaanEnabled}
              isLoading={isLoading}
            />
            {isKinerjaPenilaianDemoEnabled && <SimulationMode />}
          </>
        )}

        <CardReferensiPenilaian />

        <CardKinerjaSteps />

        <CardReferensi />
      </div>
    </div>
  )
}

export default BerandaKepalaSekolahPenilai
